import React from 'react'
import { CollapseControl, ShowIf } from '@ztechapps/webui.util'

type ExpandToggleCellProps = {
  hasChildren?: boolean
  isExpanded: boolean
  onToggle: (e: any) => void
  level: number
}

export const ExpandToggleCell = ({ hasChildren, isExpanded, onToggle, level }: ExpandToggleCellProps) => {
  const paddingLeft = level * 20

  return (
    <td style={{ width: '20px', paddingLeft }} className={`px-1 ${level > 0 ? 'table-warning' : ''}`}>
      <ShowIf condition={!!hasChildren}>
        <CollapseControl show={isExpanded} setShow={onToggle} iconShow="chevron-down" iconHide="chevron-right" />
      </ShowIf>
    </td>
  )
}
